<template>
    <div id="vms-login" class="apply-bootstrap">
        <div class="container">
            <div class="row" id="vms-login-form">
                <div id="ecLogo">
                    <img alt="eCoordinator Login Page" src="https://dev.samaritan.com/coordinator/xsl/images/eCLogo.png?1">
                </div>
                <div class="login-form-area">
                    <login-form
                        c-id="loginForm"
                        :prop-client-sso-button-config="clientSsoButtonConfig"
                        :prop-client-sso-label-after-button="clientSsoLabelAfterButton"
                        :prop-client-sso-contact-information="clientSsoContactInformation">
                    </login-form>
                </div>
                <div class="build-info">
                    <build-info></build-info>
                </div>
                <div>
                    <span class="copyright">
                        <span>
                            eCoordinator<sup class="tm">TM</sup> is a product and service of Samaritan | Volunteer Management Software (VMS)<br>
                            Copyright © 2000 - {{copyrightYear}} Samaritan Software, LLC. All rights reserved world wide.
                        </span>
                    </span>
                </div>
                <div class="privacy-policy">
                    <a href='https://samaritan.com/privacy-policy/' target='_blank'>Privacy Policy</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import "@common/syncfusionCss";
import { router } from "@common/router/router";

const vmsLoginCmp = {
    components: {
        loginForm: defineAsyncComponent(() => import('@common/loginForm/loginForm.vue'))
    },
    computed: {
        clientSsoButtonConfig() {
            let instanceName = typeof THE_CUSTOMER !== 'undefined' ? THE_CUSTOMER : '';
            instanceName = 'BEAUMONT';
            switch (instanceName) {
                case 'KP':
                case 'KPPFCC':
                case 'KPQA':
                case 'KPPFCCQA':
                    return { backgroundColor: 'green !important' };
                case 'BEAUMONT':
                    return { label: 'Beaumont Team Member Login' };
                case 'OCPS':
                case 'OCPSQA':
                    return { label: 'OCPS Employee Login' };
                case 'PCH':
                case 'PCHQA':
                    return { label: 'Login with your Phoenix Children\'s credentials' };
            }
            return null;
        },
        clientSsoLabelAfterButton() {
            if (typeof THE_CUSTOMER !== 'undefined') {
                if (THE_CUSTOMER === 'KP' || THE_CUSTOMER === 'KPPFCC' || THE_CUSTOMER === 'KPQA' || THE_CUSTOMER === 'KPPFCCQA') {
                    return `
                        <div class="login-form-sso-label">
                            <span>Use the green button below to login.</span>
                        </div>
                    `;
                }
            }
            return null;
        },
        clientSsoContactInformation() {
            let instanceName = typeof THE_CUSTOMER !== 'undefined' ? THE_CUSTOMER : '';
            instanceName = 'KP';
            switch (instanceName) {
                case 'KP':
                case 'KPPFCC':
                case 'KPQA':
                case 'KPPFCCQA':
                    return `
                        <span>
                            If you would like to become a user of eCoordinator, please contact:
                            <div>
                                <a href="https://sp-cloud.kp.org/sites/NCAL_VMS/SitePages/Help-Desk.aspx" class="sso-contact-info-link">KP VMS Support</a>
                            </div>
                        </span>
                    `;
                case 'FXCO':
                    return `<a href="mailto:vmshelp@fairfaxcounty.gov" class="sso-contact-info-link">vmshelp@fairfaxcounty.gov</a>`;
                case 'OCPS':
                case 'OCPSQA':
                    return `
                        <span>
                            If you would like to become a user of eCoordinator, please contact:
                            <div>
                                <span class="sso-contact-info-phone">(407) 317-3323</span>
                            </div>
                        </span>
                    `;
                case 'SCC':
                case 'SCCQA':
                case 'SCCDEV':
                    return `
                        <span>
                            County of Santa Clara<br>
                            <a href="mailto:Volunteer.Mgmt@esa.sccgov.org" class="sso-contact-info-link">Volunteer.Mgmt@esa.sccgov.org</a>
                        </span>
                    `;
                case 'PCH':
                case 'PCHQA':
                    return `
                        <span>
                            https://pch.samaritan.com/coordinator/ is for Phoenix Children’s Employees in the Volunteer Services Department to the Coordinator side of the Volunteer Management System.<br><br>
                            PCH Volunteer Coordinators should use the “Use PCH EMAIL and Password to login” button.<br><br>
                            If you think you should have access and you do not, please contact <a href="mailto:volunteers@phoenixchildrens.com" class="sso-contact-info-link">volunteers@phoenixchildrens.com or 602.933.0269</a>
                        </span>
                    `;
                case 'TPWD':
                    return `
                        <span>
                            If you need assistance, please contact: <a href="mailto:volunteer@tpwd.texas.gov" class="sso-contact-info-link">volunteer@tpwd.texas.gov</a>
                        </span>
                    `;
                case 'LPCHS':
                case 'LPCHSQA':
                    return `
                        <div>
                             <a href="http://samaritan.com" class="sso-contact-info-link">LPCHS Volunteer Services</a><br>
                             <a href="mailto:volunteerservices@stanfordchildrens.org" class="sso-contact-info-link">volunteerservices@stanfordchildrens.org</a>
                        </div>
                        <div>
                            <span class="sso-contact-info-phone">(650) 497-8696</span>
                        </div>
                    `;
            }
            return null;
        },
        copyrightYear() {
            return new Date().getFullYear();
        }
    },
    methods: {
        processAction: async function (act) {
            switch (act) {
                case 'login':
                    // eslint-disable-next-line no-case-declarations
                    let tmpPath = this.$route.query.redirect || '/';
                    // eslint-disable-next-line no-case-declarations
                    let tmpQuery = this.$route.query || {};
                    delete tmpQuery['redirect'];
                    router.replace({ path: tmpPath, query: tmpQuery });
                    break;
            }
        },
    }
};

export default vmsLoginCmp;
</script>

<style lang="css">

#vms-login h1, #vms-login .h1 {
    font-size: 32px;
    font-weight: 400;
}

#vms-login label {
    margin-bottom: 0;
    font-size: 14px !important;
    font-weight: 600;
    min-width: 80px;
    text-align: left;
}

#vms-login button, #vms-login input, #vms-login select, #vms-login textarea {
    background-color: transparent;
    border-style: none;
}

#vms-login .e-input {
    border-bottom-width: 0px;
    padding: 3px 5px;
}

#vms-login button {
    text-transform: none !important;
}

#vms-login {
    text-align: center;
    /*font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    margin: 0;*/
}

#vms-login .custom-message-container {
    width: 100%;
}

#vms-login-form {
    width: 490px;
    max-width: 90%;
    margin: 0 auto;
}

#vms-login #celebrationMessage {
    margin: 10px 0;
    color: #303030;
    font-size: 13px;
}

#vms-login #ecLogo {
    margin: 0 auto;
}

#vms-login #buildInfo {
    font-size: 13px;
    text-align: center;
}

#vms-login #LOGIN_FORM_BACK_TO_LOGIN_FROM_ROLE_LIST_BUTTON_loginForm {
    width: 100% !important;
    height: auto;
    padding: 5px 0 !important;
}

#vms-login .login-form-area {
    margin: 10px auto;
}

#vms-login .build-info {
    margin: 0 auto;
}

#vms-login .login-form-sso-label {
    margin: 10px 0;
    color: green;
    font-size: 14px;
    font-weight: bold;
}

#vms-login .sso-contact-info-link {
    color: #BA4614;
    text-decoration: none;
}

#vms-login .sso-contact-info-phone {
    color: #464646;
}

</style>
